(function () {
  'use strict';

  if (window.__mspReviewQuestionnaire) return;
  window.__mspReviewQuestionnaire = true;

  var SELECTORS = {
    nativeModal: '.jdgm-write-review-modal',
    nativeNext: '.jdgm-write-review-modal__nav-btn-next',
    nativeClose: '.jdgm-write-review-modal__close-btn',
    nativePage: '.jdgm-write-review-modal__page.current-page',
    writeButton: '.jm-action-buttons__button, .jdgm-write-rev-link, .jdgm-write-review'
  };
  /* Judge.me's native uploader is stricter than the approved display copy. */
  var MAX_IMAGE_COUNT = 5;
  var MAX_VIDEO_COUNT = 1;
  var MAX_IMAGE_SIZE = 10 * 1024 * 1024;
  var MAX_VIDEO_SIZE = 100 * 1024 * 1024;
  var root;
  var form;
  var activeNativeModal;
  var opener;
  var rating = 0;
  var pendingOpen = false;
  var isSubmitting = false;
  var lastFocusedElement;

  function template() {
    return [
      '<div class="msp-review-questionnaire__overlay" data-review-close></div>',
      '<div class="msp-review-questionnaire__frame">',
      '  <section class="msp-review-questionnaire__dialog" role="dialog" aria-modal="true" aria-labelledby="msp-review-title">',
      '    <button class="msp-review-questionnaire__close" type="button" aria-label="Close review form" data-review-close>',
      '      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      '    </button>',
      '    <h2 class="msp-review-questionnaire__title" id="msp-review-title">Share your experience</h2>',
      '    <form class="msp-review-questionnaire__form" novalidate>',
      '      <fieldset class="msp-review-questionnaire__field msp-review-questionnaire__field--rating">',
      '        <legend class="msp-review-questionnaire__legend">Rate your experience *</legend>',
      '        <div class="msp-review-questionnaire__stars" role="radiogroup" aria-required="true" aria-describedby="msp-review-rating-error">',
      '          <button class="msp-review-questionnaire__star" type="button" role="radio" aria-checked="false" aria-label="1 star" data-rating="1"></button>',
      '          <button class="msp-review-questionnaire__star" type="button" role="radio" aria-checked="false" aria-label="2 stars" data-rating="2"></button>',
      '          <button class="msp-review-questionnaire__star" type="button" role="radio" aria-checked="false" aria-label="3 stars" data-rating="3"></button>',
      '          <button class="msp-review-questionnaire__star" type="button" role="radio" aria-checked="false" aria-label="4 stars" data-rating="4"></button>',
      '          <button class="msp-review-questionnaire__star" type="button" role="radio" aria-checked="false" aria-label="5 stars" data-rating="5"></button>',
      '        </div>',
      '        <p class="msp-review-questionnaire__error" id="msp-review-rating-error" role="alert"></p>',
      '      </fieldset>',
      '      <div class="msp-review-questionnaire__field">',
      '        <label class="msp-review-questionnaire__label" for="msp-review-body">Write your review *</label>',
      '        <textarea class="msp-review-questionnaire__control" id="msp-review-body" name="review_body" placeholder="e.g., I loved the fabric, but shipping took longer than expected" aria-describedby="msp-review-body-error" required></textarea>',
      '        <p class="msp-review-questionnaire__error" id="msp-review-body-error" role="alert"></p>',
      '      </div>',
      '      <div class="msp-review-questionnaire__field">',
      '        <label class="msp-review-questionnaire__label" for="msp-review-short-title">A short title for your review *</label>',
      '        <input class="msp-review-questionnaire__control" id="msp-review-short-title" name="review_title" type="text" placeholder="e.g., Great quality and fast delivery" aria-describedby="msp-review-title-error" required>',
      '        <p class="msp-review-questionnaire__error" id="msp-review-title-error" role="alert"></p>',
      '      </div>',
      '      <div class="msp-review-questionnaire__person-grid">',
      '        <div class="msp-review-questionnaire__field">',
      '          <label class="msp-review-questionnaire__label" for="msp-review-name">Your name *</label>',
      '          <input class="msp-review-questionnaire__control" id="msp-review-name" name="reviewer_name" type="text" autocomplete="name" aria-describedby="msp-review-name-error" required>',
      '          <p class="msp-review-questionnaire__error" id="msp-review-name-error" role="alert"></p>',
      '        </div>',
      '        <div class="msp-review-questionnaire__field">',
      '          <label class="msp-review-questionnaire__label" for="msp-review-email">Your email address *</label>',
      '          <input class="msp-review-questionnaire__control" id="msp-review-email" name="reviewer_email" type="email" autocomplete="email" aria-describedby="msp-review-email-help msp-review-email-error" required>',
      '          <p class="msp-review-questionnaire__help" id="msp-review-email-help">We’ll use this only to verify your review. It won’t be shown publicly.</p>',
      '          <p class="msp-review-questionnaire__error" id="msp-review-email-error" role="alert"></p>',
      '        </div>',
      '      </div>',
      '      <div class="msp-review-questionnaire__field">',
      '        <span class="msp-review-questionnaire__label">Add photos or videos</span>',
      '        <input class="msp-review-questionnaire__file-input" id="msp-review-media" name="media" type="file" accept="image/*,video/*" multiple aria-describedby="msp-review-media-help msp-review-media-error">',
      '        <label class="msp-review-questionnaire__upload" for="msp-review-media">',
      '          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M5 14v5h14v-5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '          Upload files',
      '        </label>',
      '        <p class="msp-review-questionnaire__help" id="msp-review-media-help">Upload up to 10 images (15 MB each) and 3 short videos (2 GB each)</p>',
      '        <p class="msp-review-questionnaire__error" id="msp-review-media-error" role="alert"></p>',
      '        <ul class="msp-review-questionnaire__file-list" aria-live="polite"></ul>',
      '      </div>',
      chipGroup('comfort', 'How comfortable are our shoes?', ['VERY UNCOMFORTABLE', 'UNCOMFORTABLE', 'OKAY', 'COMFORTABLE', 'VERY COMFORTABLE']),
      chipGroup('size', 'How do you find the size of the shoe?', ['THEY RUN SMALL', 'TRUE TO SIZE', 'THEY RUN BIG']),
      chipGroup('width', 'How do you find the Width of the shoe?', ['RUNS NARROW', 'JUST RIGHT', 'RUNS WIDE']),
      '      <p class="msp-review-questionnaire__status" role="status" aria-live="polite"></p>',
      '      <footer class="msp-review-questionnaire__footer">',
      '        <p class="msp-review-questionnaire__required-note">* required fields</p>',
      '        <button class="msp-review-questionnaire__send" type="submit">Send</button>',
      '      </footer>',
      '    </form>',
      '  </section>',
      '</div>'
    ].join('');
  }

  function chipGroup(name, label, options) {
    var chips = options.map(function (option, index) {
      var id = 'msp-review-' + name + '-' + index;
      return [
        '<input class="msp-review-questionnaire__chip-input" id="', id, '" type="radio" name="', name, '" value="', option, '">',
        '<label class="msp-review-questionnaire__chip" for="', id, '">', option, '</label>'
      ].join('');
    }).join('');
    return [
      '<fieldset class="msp-review-questionnaire__field" data-fit-question="', name, '">',
      '  <legend class="msp-review-questionnaire__legend">', label, '<span class="msp-review-questionnaire__choice-help">Choose one option</span></legend>',
      '  <div class="msp-review-questionnaire__chips">', chips, '</div>',
      '</fieldset>'
    ].join('');
  }

  function mount() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'msp-review-questionnaire';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML = template();
    document.body.appendChild(root);
    form = root.querySelector('form');

    root.addEventListener('click', function (event) {
      var closeTarget = event.target.closest('[data-review-close]');
      var star = event.target.closest('[data-rating]');
      if (closeTarget) closeQuestionnaire();
      if (star) setRating(Number(star.getAttribute('data-rating')), true);
    });
    root.addEventListener('keydown', onRootKeydown);
    form.addEventListener('submit', onSubmit);
    form.querySelector('#msp-review-media').addEventListener('change', onFilesChanged);
    form.addEventListener('input', clearFieldError);
  }

  function setRating(value, focusStar) {
    rating = value;
    root.querySelectorAll('[data-rating]').forEach(function (star) {
      var selected = Number(star.getAttribute('data-rating')) <= rating;
      star.classList.toggle('is-selected', selected);
      star.setAttribute('aria-checked', Number(star.getAttribute('data-rating')) === rating ? 'true' : 'false');
      star.setAttribute('tabindex', Number(star.getAttribute('data-rating')) === rating ? '0' : '-1');
    });
    setError('rating', '');
    if (focusStar) root.querySelector('[data-rating="' + value + '"]').focus();
  }

  function onRootKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeQuestionnaire();
      return;
    }
    var star = event.target.closest('[data-rating]');
    if (star && ['ArrowLeft', 'ArrowDown', 'ArrowRight', 'ArrowUp'].indexOf(event.key) !== -1) {
      event.preventDefault();
      var direction = event.key === 'ArrowLeft' || event.key === 'ArrowDown' ? -1 : 1;
      setRating(Math.min(5, Math.max(1, Number(star.getAttribute('data-rating')) + direction)), true);
      return;
    }
    if (event.key === 'Tab') trapFocus(event);
  }

  function trapFocus(event) {
    var focusable = Array.prototype.slice.call(root.querySelectorAll('button:not(:disabled), input:not([type="hidden"]):not(:disabled), textarea:not(:disabled)'))
      .filter(function (element) { return element.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function clearFieldError(event) {
    var target = event.target;
    if (!target.name) return;
    var key = target.name === 'review_body' ? 'body' : target.name === 'review_title' ? 'title' : target.name === 'reviewer_name' ? 'name' : target.name === 'reviewer_email' ? 'email' : '';
    if (key && target.value.trim()) setError(key, '');
  }

  function setError(key, message) {
    var error = root.querySelector('#msp-review-' + key + '-error');
    var control = key === 'rating' ? root.querySelector('.msp-review-questionnaire__stars') : root.querySelector('[aria-describedby*="msp-review-' + key + '-error"]');
    if (error) error.textContent = message;
    if (control) control.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  function validate() {
    var firstInvalid;
    var fields = [
      { key: 'body', element: form.elements.review_body, message: 'This field is required' },
      { key: 'title', element: form.elements.review_title, message: 'This field is required' },
      { key: 'name', element: form.elements.reviewer_name, message: 'This field is required' },
      { key: 'email', element: form.elements.reviewer_email, message: 'This field is required' }
    ];
    if (!rating) {
      setError('rating', 'A star rating is required');
      firstInvalid = root.querySelector('[data-rating="1"]');
    } else {
      setError('rating', '');
    }
    fields.forEach(function (field) {
      var value = field.element.value.trim();
      var message = value ? '' : field.message;
      if (field.key === 'email' && value && !field.element.validity.valid) message = 'Enter a valid email address';
      setError(field.key, message);
      if (message && !firstInvalid) firstInvalid = field.element;
    });
    var filesValid = validateFiles(form.elements.media.files, true);
    if (!filesValid && !firstInvalid) firstInvalid = form.elements.media;
    if (firstInvalid) {
      firstInvalid.focus();
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    return true;
  }

  function validateFiles(files, renderError) {
    var images = 0;
    var videos = 0;
    var message = '';
    Array.prototype.forEach.call(files || [], function (file) {
      if (file.type.indexOf('image/') === 0) {
        images += 1;
        if (file.size > MAX_IMAGE_SIZE) message = 'Judge.me currently accepts images up to 10 MB each.';
      } else if (file.type.indexOf('video/') === 0) {
        videos += 1;
        if (file.size > MAX_VIDEO_SIZE) message = 'Judge.me currently accepts videos up to 100 MB each.';
      } else {
        message = 'Choose image or video files only.';
      }
    });
    if (images > MAX_IMAGE_COUNT) message = 'Judge.me currently accepts up to 5 images per review.';
    if (videos > MAX_VIDEO_COUNT) message = 'Judge.me currently accepts 1 video per review.';
    if (renderError) setError('media', message);
    return !message;
  }

  function onFilesChanged(event) {
    var files = event.target.files;
    var valid = validateFiles(files, true);
    var list = root.querySelector('.msp-review-questionnaire__file-list');
    list.innerHTML = '';
    if (!valid) {
      event.target.value = '';
      return;
    }
    Array.prototype.forEach.call(files, function (file) {
      var item = document.createElement('li');
      item.textContent = file.name + ' · ' + formatBytes(file.size);
      list.appendChild(item);
    });
  }

  function formatBytes(bytes) {
    if (bytes >= 1024 * 1024 * 1024) return (bytes / (1024 * 1024 * 1024)).toFixed(1) + ' GB';
    if (bytes >= 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    return Math.max(1, Math.round(bytes / 1024)) + ' KB';
  }

  function resetQuestionnaire() {
    form.reset();
    rating = 0;
    isSubmitting = false;
    root.querySelectorAll('[data-rating]').forEach(function (star, index) {
      star.classList.remove('is-selected');
      star.setAttribute('aria-checked', 'false');
      star.setAttribute('tabindex', index === 0 ? '0' : '-1');
    });
    root.querySelectorAll('.msp-review-questionnaire__error').forEach(function (error) { error.textContent = ''; });
    root.querySelectorAll('[aria-invalid]').forEach(function (control) { control.setAttribute('aria-invalid', 'false'); });
    root.querySelector('.msp-review-questionnaire__file-list').innerHTML = '';
    setStatus('');
    var send = root.querySelector('.msp-review-questionnaire__send');
    send.disabled = false;
    send.textContent = 'Send';
  }

  function openQuestionnaire(nativeModal, source) {
    mount();
    if (root.classList.contains('is-open')) return;
    activeNativeModal = nativeModal;
    opener = source || opener || document.activeElement;
    lastFocusedElement = document.activeElement;
    resetQuestionnaire();
    prefillFromNative(nativeModal);
    nativeModal.classList.add('msp-review-questionnaire-native');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('msp-review-questionnaire-open');
    root.querySelector('[data-rating="1"]').focus();
  }

  function closeQuestionnaire() {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('msp-review-questionnaire-open');
    if (activeNativeModal) {
      activeNativeModal.classList.remove('msp-review-questionnaire-native');
      var close = activeNativeModal.querySelector(SELECTORS.nativeClose);
      if (close) close.click();
    }
    activeNativeModal = null;
    isSubmitting = false;
    if (opener && document.contains(opener)) opener.focus();
    else if (lastFocusedElement && document.contains(lastFocusedElement)) lastFocusedElement.focus();
  }

  function prefillFromNative(nativeModal) {
    var mappings = [
      ['#jdgm-review-body-input', 'review_body'],
      ['#jdgm-review-title-input', 'review_title'],
      ['#jdgm-name-input', 'reviewer_name'],
      ['#jdgm-email-input', 'reviewer_email']
    ];
    mappings.forEach(function (mapping) {
      var nativeInput = nativeModal.querySelector(mapping[0]);
      if (nativeInput && nativeInput.value) form.elements[mapping[1]].value = nativeInput.value;
    });
  }

  function fitAnswers() {
    return [
      { key: 'comfort', question: 'How comfortable are our shoes?', label: 'Comfort' },
      { key: 'size', question: 'How do you find the size of the shoe?', label: 'Size' },
      { key: 'width', question: 'How do you find the Width of the shoe?', label: 'Width' }
    ].map(function (item) {
      var selected = form.querySelector('input[name="' + item.key + '"]:checked');
      return { question: item.question, label: item.label, value: selected ? selected.value : '' };
    }).filter(function (item) { return item.value; });
  }

  function normalizeText(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function mapFitAnswersToNative(nativeModal, answers) {
    var groups = Array.prototype.slice.call(nativeModal.querySelectorAll('.jdgm-write-review-modal__field-group.jdgm-cf'));
    return answers.filter(function (answer) {
      var group = groups.find(function (candidate) {
        var label = candidate.querySelector('.jdgm-write-review-modal__field-label');
        return label && normalizeText(label.textContent) === normalizeText(answer.question);
      });
      if (!group) return true;
      var option = Array.prototype.slice.call(group.querySelectorAll('.jdgm-cf__option')).find(function (candidate) {
        return normalizeText(candidate.textContent) === normalizeText(answer.value);
      });
      var input = option && option.querySelector('input');
      if (!input) return true;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return false;
    });
  }

  function serializeFitAnswers(body, answers) {
    if (!answers.length) return body;
    var block = ['[Product fit feedback]'];
    answers.forEach(function (answer) { block.push(answer.label + ': ' + answer.value); });
    block.push('[/Product fit feedback]');
    return body.replace(/\s+$/, '') + '\n\n' + block.join('\n');
  }

  function setNativeValue(nativeModal, selector, value) {
    var input = nativeModal.querySelector(selector);
    if (!input) throw new Error('The review service is missing a required field. Please close and try again.');
    input.value = value;
    input.setAttribute('value', value);
    if (input.dataset) input.dataset.manuallyEdited = 'true';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('blur', { bubbles: true }));
    return input;
  }

  function selectNativeRating(nativeModal, pageSelector) {
    var star = nativeModal.querySelector(pageSelector + ' .jdgm-star[data-alt="' + rating + '"]');
    if (!star) {
      var stars = nativeModal.querySelectorAll(pageSelector + ' .jdgm-star');
      star = stars[rating - 1];
    }
    if (!star) throw new Error('The review service is missing the rating control. Please close and try again.');
    star.click();
  }

  function copyMediaToNative(nativeModal) {
    var files = form.elements.media.files;
    if (!files || !files.length) return;
    var nativeInput = nativeModal.querySelector('.jdgm-write-review-modal__media-input');
    if (!nativeInput) throw new Error('Media upload is temporarily unavailable. Remove the files or try again.');
    var transfer = new DataTransfer();
    Array.prototype.forEach.call(files, function (file) { transfer.items.add(file); });
    nativeInput.files = transfer.files;
    nativeInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  async function syncToNative(nativeModal) {
    selectNativeRating(nativeModal, '.jdgm-write-review-modal__page--review-form-intro');
    await waitFor(function () {
      var page = nativeModal.querySelector(SELECTORS.nativePage);
      return page && !page.classList.contains('jdgm-write-review-modal__page--review-form-intro');
    }, 2500);
    selectNativeRating(nativeModal, '.jdgm-write-review-modal__page--review-details');

    var answers = fitAnswers();
    var unmappedAnswers = mapFitAnswersToNative(nativeModal, answers);
    var submittedBody = serializeFitAnswers(form.elements.review_body.value.trim(), unmappedAnswers);
    setNativeValue(nativeModal, '#jdgm-review-body-input', submittedBody);
    setNativeValue(nativeModal, '#jdgm-review-title-input', form.elements.review_title.value.trim());
    setNativeValue(nativeModal, '#jdgm-name-input', form.elements.reviewer_name.value.trim());
    setNativeValue(nativeModal, '#jdgm-email-input', form.elements.reviewer_email.value.trim());
    var verificationEmail = nativeModal.querySelector('#jdgm-verification-email-input');
    if (verificationEmail) setNativeValue(nativeModal, '#jdgm-verification-email-input', form.elements.reviewer_email.value.trim());
    copyMediaToNative(nativeModal);
  }

  async function submitThroughNative(nativeModal) {
    for (var step = 0; step < 10; step += 1) {
      var page = nativeModal.querySelector(SELECTORS.nativePage);
      if (!page) throw new Error('The review service did not finish loading. Please try again.');
      if (page.classList.contains('jdgm-write-review-modal__page--thank-you')) return;
      if (page.classList.contains('jdgm-write-review-modal__page--check-email')) {
        throw new Error('Please check your email to continue your verified review.');
      }
      if (page.classList.contains('jdgm-write-review-modal__page--share-media') && form.elements.media.files.length) {
        await waitForNativeUploads(nativeModal);
      }
      var pageNumber = page.getAttribute('data-page');
      var next = nativeModal.querySelector(SELECTORS.nativeNext);
      if (!next) throw new Error('The review service is missing its submit control. Please try again.');
      next.click();
      var changed = await waitFor(function () {
        var current = nativeModal.querySelector(SELECTORS.nativePage);
        return current && (current.classList.contains('jdgm-write-review-modal__page--thank-you') || String(current.getAttribute('data-page')) !== String(pageNumber));
      }, 20000, true);
      if (!changed) {
        var nativeError = Array.prototype.slice.call(nativeModal.querySelectorAll('.jdgm-write-review-modal__field-error')).find(function (error) {
          return error.textContent.trim() && getComputedStyle(error).display !== 'none';
        });
        throw new Error(nativeError ? nativeError.textContent.trim() : 'The review could not be sent. Please try again.');
      }
      if (nativeModal.querySelector('.jdgm-write-review-modal__page--thank-you.current-page')) return;
    }
    throw new Error('The review service did not complete the submission. Please try again.');
  }

  async function waitForNativeUploads(nativeModal) {
    var complete = await waitFor(function () {
      return !nativeModal.querySelector('.jdgm-is-uploading, .jdgm-write-review-modal__spinner-wrapper:not([style*="display: none"])');
    }, 60000, true);
    if (!complete) throw new Error('Your media is still uploading. Please wait and try again.');
  }

  function waitFor(check, timeout, returnFalse) {
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      function poll() {
        var result = false;
        try { result = check(); } catch (error) { reject(error); return; }
        if (result) { resolve(result); return; }
        if (Date.now() - started >= timeout) {
          if (returnFalse) resolve(false);
          else reject(new Error('The review service did not respond. Please try again.'));
          return;
        }
        window.setTimeout(poll, 50);
      }
      poll();
    });
  }

  function setStatus(message, success) {
    if (!root) return;
    var status = root.querySelector('.msp-review-questionnaire__status');
    status.textContent = message;
    status.style.color = success ? '#794f23' : '';
  }

  async function onSubmit(event) {
    event.preventDefault();
    if (isSubmitting || !validate()) return;
    if (!activeNativeModal) {
      setStatus('The review service is not ready. Close this form and try again.');
      return;
    }
    isSubmitting = true;
    var send = root.querySelector('.msp-review-questionnaire__send');
    send.disabled = true;
    send.textContent = 'Sending…';
    setStatus('');
    try {
      await syncToNative(activeNativeModal);
      await submitThroughNative(activeNativeModal);
      setStatus('Thank you. Your review has been sent.', true);
      send.textContent = 'Sent';
    } catch (error) {
      isSubmitting = false;
      send.disabled = false;
      send.textContent = 'Send';
      setStatus(error && error.message ? error.message : 'The review could not be sent. Please try again.');
    }
  }

  function isWriteReviewTrigger(element) {
    if (!element || !element.matches(SELECTORS.writeButton)) return false;
    if (!element.closest('.apps-section')) return false;
    return /write\s+a?\s*review/i.test(element.textContent || element.getAttribute('aria-label') || '');
  }

  function findVisibleNativeModal() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTORS.nativeModal)).find(function (modal) {
      return modal !== root && getComputedStyle(modal).display !== 'none';
    });
  }

  function waitForNativeModal(source) {
    waitFor(findVisibleNativeModal, 5000).then(function (nativeModal) {
      if (!pendingOpen) return;
      pendingOpen = false;
      openQuestionnaire(nativeModal, source);
    }).catch(function () { pendingOpen = false; });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(SELECTORS.writeButton);
    if (!isWriteReviewTrigger(trigger)) return;
    pendingOpen = true;
    opener = trigger;
    window.setTimeout(function () { waitForNativeModal(trigger); }, 0);
  });

  document.addEventListener('jdgm.modal.opened', function () {
    if (pendingOpen) waitForNativeModal(opener);
  });

  if (window.__MSP_REVIEW_QUESTIONNAIRE_TEST__) {
    window.__mspReviewQuestionnaireTestHooks = {
      mapFitAnswersToNative: mapFitAnswersToNative,
      serializeFitAnswers: serializeFitAnswers
    };
  }
})();
